// Smooth scrolling is handled purely via CSS (html { scroll-behavior: smooth }).
// No JS scroll library is used, so there is no lifecycle/ref cleanup that can crash under React 19.
export default function SmoothScroll({ children }) {
  return children;
}
